import React from 'react'

export default function SettingsWrapper({ children }: { children: React.ReactNode }): JSX.Element {
  return <div className={'settings'}>{children}</div>
}
